<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_267_116794)">
<path d="M6.26835 0.929994C9.53549 -0.067149 8.72835 5.38714 7.20835 10.5686C5.73692 15.5829 3.43264 20.7357 1.42121 18.7543C-1.01308 16.3543 4.13549 14.3314 9.57121 12.6829C14.5669 11.1671 20.0726 10.34 19.0812 13.47C18.1941 16.2743 14.3426 13.1929 10.4184 9.50714C6.58549 5.91142 3.18978 1.87142 6.26835 0.929994Z" stroke="#AC986A" stroke-width="1.5"/>
</g>
<defs>
<clipPath id="clip0_267_116794">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
</template>